import { FC } from "react"
import { MainLayout } from "./MainLayout"

export const HomePage: FC = () => {
  return <MainLayout>home page</MainLayout>
}
